/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SystemNote } from '../../models/system-note';

export interface GetList_3$Params {
}

export function getList_3(http: HttpClient, rootUrl: string, params?: GetList_3$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SystemNote>>> {
  const rb = new RequestBuilder(rootUrl, getList_3.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SystemNote>>;
    })
  );
}

getList_3.PATH = '/api/system/note';
